// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 522) return "static/css/522.684473c2fda97e2736bb.lib.css";
	if (chunkId === 343) return "static/css/343.d358fff0df73552dbef3.css";
	// return url for filenames based on template
	return undefined;
};